module.exports = __webpack_public_path__ + "img/login_forgot_onboarding.eb4c5a3a.webp";